<template>
	<div id="map"></div>
</template>

<script>

import {Loader, LoaderOptions} from "google-maps";
import {mapGetters, mapActions, mapMutations} from "vuex";

export default {
	name: "PartnersGoogleMap",
	props: ['apikey', 'localization'],

	data() {
		return {
			map: null, // Google map object
			loader: null, // Google loader object
			google: null, // Google object
			markers: [] // Markers array
		}
	},

	computed: {
		...mapGetters(['offices', "getSelectedContinent", "getChangeContinent"])
	},

	methods: {
		...mapActions(['fetchOfficesData']),
		...mapMutations(['setChangeContinent']),
		addMarkers() { // add markers to map from offices object
			this.removeMarkers();
			this.offices.forEach((office) => {

				let icon = {
					url: "/assets/icons/" + this.getIcon(office), // url
					scaledSize: new this.google.maps.Size(30,40), // scaled size
				};

				let marker = new this.google.maps.Marker({
					position: {lat: office.gps_lat, lng: office.gps_lon},
					map: this.map,
					icon: icon,
					url: office.web['sk']
				});

				let infowindow = new this.google.maps.InfoWindow({
					content: this.getLocaleProperty(office.name, this.locale)
				});

				this.google.maps.event.addListener(marker, 'click', () => {
					// infowindow.open(this.map, marker);
					if(office.web['sk'] !== "" && office.web['sk'] !== null) {
						window.open(
							office.web['sk'],
							'_blank'
						)
					} else {
						infowindow.open(this.map, marker);
					}
				});
				this.google.maps.event.addListener(marker, 'mouseover', () => {
					infowindow.open(this.map, marker);
				})
				this.google.maps.event.addListener(marker, 'mouseout', () => {
					infowindow.close();
				});

				this.markers.push(marker);
			});
		},
		getIcon(office) {
			if (office.dental_technology_type && office.anesthetic_technology_type) {
				return "stomatologicka-dychacia.png";
			} else if (office.dental_technology_type) {
				return "stomatologicka-technika.png"
			} else if (office.anesthetic_technology_type) {
				return "anesteticka-a-dychacia-technika.png";
			}
		},
		getLocaleProperty(object, locale) {
			if (typeof object[locale] === "undefined") {
				return object["sk"];
			} else {
				return object[locale];
			}
		},
		removeMarkers() { // remove markers from map
			for(let i=0; i<this.markers.length; i++){
				this.markers[i].setMap(null);
			}

			this.markers.length = 0;
		},
	},

	mounted() {
		this.loader = new Loader(this.apikey, {language: this.localization});

		this.loader.load().then((google) => {
			this.google = google;
			this.map = new this.google.maps.Map(document.getElementById('map'), {
				center: {lat: 48.142568, lng: 17.0958693},
				zoom: 3,
				mapTypeControl:false,
			});
		});
	},

	watch: {
		offices() {
			if(this.getChangeContinent) {
				switch (this.getSelectedContinent) {
					case 1:
						var coordinates = {lat: 37.09024, lng: -95.712891}
						var zoom = 4
						break
					case 2:
						var coordinates = {lat: 47.03461422220549, lng: 77.34860755698526}
						var zoom = 2
						break
					case 3:
						var coordinates = {lat: 48.142568, lng: 17.0958693}
						var zoom = 3
						break
					case 4:
						var coordinates = {lat: 0, lng: 0}
						var zoom = 1
						break
					case 5:
						var coordinates = {lat: 31.047224051729625, lng: 37.9630489080292}
						var zoom = 4
						break
					default:
						var coordinates = {lat: 48.142568, lng: 17.0958693}
						var zoom = 3
				}
			} else  {
				var coordinates = {lat: this.offices[0].gps_lat, lng: this.offices[0].gps_lon}
				var zoom = 5
			}
			this.map = new this.google.maps.Map(document.getElementById('map'), {
				center: coordinates,
				zoom: zoom,
				mapTypeControl: false,
			})
			this.addMarkers();
		},
	}
}
</script>

<style scoped>

</style>
